import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import { GET_COMPREHENSIVE_ANALYTICS } from '../graphql/queries/getComprehensiveAnalytics';

interface UseGetComprehensiveAnalyticsParams {
  communityId: string;
  fromDate: string;
  toDate: string;
  skip?: boolean;
}

export function useGetComprehensiveAnalytics({ communityId, fromDate, toDate, skip = false }: UseGetComprehensiveAnalyticsParams) {
  const { data, loading, error, refetch } = useQuery(GET_COMPREHENSIVE_ANALYTICS, {
    variables: {
      communityId,
      fromDate,
      toDate,
    },
    skip,
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  });

  const comprehensiveAnalytics = useMemo(() => data?.community?.comprehensiveAnalytics || null, [data]);

  return {
    comprehensiveAnalytics,
    isLoading: loading,
    error,
    refetch,
  };
}
